<template>
  <div>
    <vue-good-table mode="remote" @on-page-change="onPageChange" @on-sort-change="onSortChange"
      @on-column-filter="onColumnFilter" @on-per-page-change="onPerPageChange" :totalRows="table.total_records"
      :isLoading.sync="table.isLoading" :pagination-options="{
            enabled: true,
            dropdownAllowAll: false,
            perPageDropdown: [10, 25, 50, 100],
          }" :columns="table.columns" :rows="table.rows">
      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field == 'action'">
          <router-link :to="'/admin/node-server/edit?id=' + props.row.id">
            <button class="btn btn-primary text-white margin5">Edit</button>
          </router-link>
        </span>
        <span v-else-if="props.column.field == 'multidevice'">
          <span class="badge badge-success" v-if="props.row.multidevice == 1">Yes</span>
          <span class="badge badge-secondary" v-else>No</span>
        </span>
        <span v-else-if="props.column.field == 'dev_only'">
          <span class="badge badge-info" v-if="props.row.dev_only == 1">Yes</span>
          <span class="badge badge-danger" v-else>No</span>
        </span>
        <span v-else-if="props.column.field == 'hide'">
          <span class="badge badge-danger" v-if="props.row.hide == 1">Inactive</span>
          <span class="badge badge-success" v-else>Active</span>
        </span>
        <span v-else-if="props.column.field == 'created_at'">
          {{ formatDate(props.row.created_at) }}
        </span>
        <span v-else-if="props.column.field == 'updated_at'">
          {{ formatDate(props.row.updated_at) }}
        </span>
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>
    </vue-good-table>
  </div>
</template>

<script>
  import moment from 'moment'

  export default {
    data() {
      return {
        table: {
          total_records: 0,
          isLoading: true,
          columns: [{
              label: "ID",
              field: "id",
              filterOptions: {
                enabled: false,
              },
              sortable: false,
              width: "8%",
            },
            {
              label: "URL",
              field: "url",
              filterOptions: {
                enabled: true,
              },
              sortable: false,
              width: "20%",
            },
            {
              label: "Token",
              field: "token",
              filterOptions: {
                enabled: true,
              },
              sortable: false,
              width: "15%",
            },
            {
              label: "Device Count",
              field: "device_count",
              filterOptions: {
                enabled: false,
              },
              sortable: false,
              width: "10%",
            },
            {
              label: "Dev Only",
              field: "dev_only",
              filterOptions: {
                enabled: false,
              },
              sortable: false,
              width: "8%",
            },
            {
              label: "Status",
              field: "hide",
              filterOptions: {
                enabled: false,
              },
              sortable: false,
              width: "8%",
            },
            {
              label: "Action",
              field: "action",
              sortable: false,
              width: "15%",
            },
          ],
          rows: [],
          serverParams: {
            columnFilters: {},
            sort: [{
              field: "id",
              type: "desc",
            }, ],
            page: 1,
            limit: 10,
          },
        },
      };
    },
    mounted() {
      this.fn = () => {
        this.loadItems();
      }
      this.$root.$on("refresh_table", this.fn);
      this.loadItems();
    },
    beforeDestroy() {
      this.$root.$off("refresh_table", this.fn);
    },
    methods: {
      updateParams(newProps) {
        this.table.serverParams = Object.assign({},
          this.table.serverParams,
          newProps
        );
      },
      onPageChange(params) {
        this.updateParams({
          page: params.currentPage
        });
        this.loadItems();
      },
      onPerPageChange(params) {
        this.updateParams({
          limit: params.currentPerPage
        });
        this.loadItems();
      },
      onSortChange(params) {
        this.updateParams({
          sort: [{
            type: params.sortType,
            field: this.table.columns[params.columnIndex].field,
          }, ],
        });
        this.loadItems();
      },
      onColumnFilter(params) {
        this.updateParams(params);
        this.loadItems();
      },
      async loadItems() {
        this.table.isLoading = true
        try {
          let response = await this.getFromServer(this.table.serverParams);
          this.table.total_records = response.data.data.total_records || 0;
          this.table.rows = response.data.data.node_servers || [];
        } catch (err) {
          this.$toast.error("Failed to load node servers");
          console.error(err);
        }
        this.table.isLoading = false
      },
      async getFromServer(param) {
        return await this.$store.dispatch("admin_node_servers_list", param);
      },
      formatDate(timestamp) {
        if (!timestamp) return '-';
        return moment.unix(timestamp / 1000).format('YYYY-MM-DD HH:mm:ss');
      },
      async deleteNodeServer(id) {
        if (!confirm("Are you sure you want to delete this node server?")) return;

        try {
          await this.$store.dispatch("admin_node_server_delete", id);
          this.$toast.success("Node server deleted successfully");
          this.loadItems();
        } catch (err) {
          this.$toast.error("Failed to delete node server");
          console.error(err);
        }
      }
    },
  };
</script>

<style scoped>
  .margin5 {
    margin: 5px;
  }
</style>
